import classNames from 'classnames';
import React from 'react';
import { Label } from './styles';

export type UDFormLabelProps = React.DetailedHTMLProps<React.LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>;

const UDFormLabel = (props: UDFormLabelProps) => {
  const { children, className, style, ...otherProps } = props;
  return (
    <Label
      {...otherProps}
      className={classNames('text callout text-surfaceRomanSilver30', className)}
      // Начертание — своё, остальное отдаём вызывающей стороне. Раньше здесь
      // стоял просто объект, и переданный `style` затирался целиком: подпись
      // поля «Фото» в публичной заявке просила белый цвет на тёмном фоне и не
      // получала его.
      style={{ fontFamily: 'SF Pro Text', fontWeight: 400, ...style }}
    >
      {children}
    </Label>
  );
};

export default UDFormLabel;
